import { type ReactNode } from 'react';
import { useConfig, useSetConfig } from '../hooks/use-config';
import { ToggleField } from './settings-field';

function parseOpen(value: unknown): boolean {
  return value === true || value === 'true';
}

export function RegistrationToggle(): ReactNode {
  const { data: cfg, isLoading } = useConfig('registration_open');
  const save = useSetConfig();
  if (isLoading || cfg === undefined) return null;
  const on = cfg === null ? true : parseOpen(cfg.value);
  const toggle = (v: boolean): void => {
    save.mutate({ key: 'registration_open', value: v });
  };
  return <ToggleField label="Registro abierto" value={on} onChange={toggle} />;
}
